import { Box } from "@mui/joy";
import { mailEditorShellSx } from "../../../styles/globalStyles";
import { smsEditorBelowToolbarSx } from "./smsEditorShared";
import { useSMSTemplatesPageState } from "./hooks/useSMSTemplatesPageState";
import SMSEditorToolbar from "./display/SMSEditorToolbar";
import SMSEditorBodyWorkspace from "./display/SMSEditorBodyWorkspace";

export default function SMSTemplatesPage() {
  const {
    canEdit,
    loading,
    saving,
    templates,
    template,
    setTemplate,
    placeholders,
    previewText,
    bodyRef,
    onSelectTemplateId,
    onNewTemplate,
    onSave,
    onDelete,
    onActiveChange,
  } = useSMSTemplatesPageState();

  return (
    <Box sx={mailEditorShellSx}>
      <SMSEditorToolbar
        templates={templates}
        template={template}
        loading={loading}
        saving={saving}
        canEdit={canEdit}
        onSelectTemplateId={onSelectTemplateId}
        onNewTemplate={onNewTemplate}
        onSave={onSave}
        onDelete={onDelete}
        onActiveChange={onActiveChange}
        onTemplateChange={setTemplate}
      />

      <Box sx={smsEditorBelowToolbarSx}>
        <SMSEditorBodyWorkspace
          template={template}
          onTemplateChange={setTemplate}
          canEdit={canEdit}
          placeholders={placeholders}
          editorRef={bodyRef}
          previewText={previewText}
        />
      </Box>
    </Box>
  );
}
